/** FAQ, Support, and Advertising page copy (Romanian translation). */
export const pagesMessagesRo = {
  faq: {
    pageTitle: "Întrebări frecvente",
    pageSubtitle: "Găsiți răspunsuri la întrebările frecvente despre WasOK",
    seoTitle: "Întrebări frecvente — WasOK",
    seoDescription:
      "Răspunsuri la întrebările frecvente despre WasOK, scanarea produselor, confidențialitate și evaluări.",
    items: [
      {
        question: "Cum funcționează WasOK?",
        answer:
          "WasOK vă ajută să vă amintiți ce produse v-au plăcut sau nu, scanând coduri de bare și salvând evaluările și notele dvs. Pur și simplu scanați codul de bare al unui produs, evaluați-l, adăugați note, iar data viitoare când scanați același produs, veți vedea instant recenzia dvs. anterioară.",
      },
      {
        question: "Sunt datele mele stocate în cloud?",
        answer:
          "Nu! Toate datele dvs. sunt stocate local pe dispozitivul dvs. Nu sincronizăm informațiile dvs. cu cloud-ul, ceea ce înseamnă că istoricul dvs. de cumpărături și opiniile despre produse rămân complet private. Totuși, aceasta înseamnă și că ar trebui să faceți o copie de rezervă a dispozitivului dacă doriți să vă păstrați datele.",
      },
      {
        question: "Am nevoie de o conexiune la internet pentru a folosi WasOK?",
        answer:
          "Nu, WasOK funcționează complet offline. Deoarece toate datele dvs. sunt stocate local pe dispozitiv, puteți scana produse, adăuga evaluări și vizualiza istoricul fără nicio conexiune la internet.",
      },
      {
        question: "Pot folosi WasOK pentru orice tip de produs?",
        answer:
          "Da! WasOK funcționează cu orice produs care are un cod de bare. Fie că este vorba de alimente, cosmetice, articole de uz casnic, electronice sau orice altceva cu un cod de bare, îl puteți scana și salva opiniile dvs.",
      },
      {
        question: "Cum scanez un cod de bare?",
        answer:
          "Pur și simplu deschideți aplicația WasOK și apăsați butonul de scanare. Îndreptați camera către codul de bare al produsului, iar aplicația îl va detecta și scana automat. Asigurați-vă că codul de bare este bine iluminat și în focus pentru cele mai bune rezultate.",
      },
      {
        question: "Pot adăuga fotografii la recenziile mele de produse?",
        answer:
          "Da! Puteți atașa fotografii la orice recenzie de produs. Acest lucru este deosebit de util pentru a vă aminti detaliile ambalajului, listele de ingrediente sau orice altă informație vizuală care v-ar putea ajuta să vă amintiți de ce v-a plăcut sau nu un produs.",
      },
      {
        question: "Ce informații pot salva despre produse?",
        answer:
          "Puteți salva evaluări (1-5 stele), note text, fotografii, prețul pe care l-ați plătit, unde l-ați cumpărat și categorii personalizate. Aceste informații complete vă ajută să luați decizii informate la cumpărături.",
      },
      {
        question: "Pot crea liste de cumpărături?",
        answer:
          "Da! WasOK vă permite să creați liste de cumpărături din produsele pe care le-ați evaluat deja. Acest lucru face mai ușor să vă amintiți ce produse v-au plăcut și pe care doriți să le cumpărați din nou.",
      },
      {
        question: "Cum îmi organizez produsele?",
        answer:
          "Puteți organiza produsele folosind categorii personalizate. De exemplu, ați putea crea categorii precum „Gustări”, „Cafea”, „Îngrijirea pielii” sau „Produse de curățenie”. Acest lucru face mai ușoară răsfoirea recenziilor dvs. după tip.",
      },
      {
        question: "Este WasOK gratuit?",
        answer:
          "Da, WasOK este complet gratuit pentru descărcare și utilizare. Nu există achiziții în aplicație, abonamente sau taxe ascunse. Credem că toată lumea ar trebui să aibă acces la o modalitate privată de a-și aminti preferințele privind produsele.",
      },
      {
        question: "Este WasOK accesibil?",
        answer:
          "WasOK este conceput pentru a fi utilizabil de cât mai multe persoane posibil. Aplicația include funcții de accesibilitate precum suport pentru cititoare de ecran, text scalabil și un mod opțional de contrast ridicat.",
      },
      {
        question: "Ce se întâmplă dacă dezinstalez aplicația?",
        answer:
          "Deoarece toate datele sunt stocate local pe dispozitiv, dezinstalarea aplicației va șterge toate recenziile, notele și listele de cumpărături ale produselor dvs. Asigurați-vă că exportați datele dvs. dacă doriți să păstrați o copie de rezervă înainte de dezinstalare.",
      },
      {
        question: "Pot exporta datele mele?",
        answer:
          "Da, WasOK vă permite să exportați datele în scopuri de backup. Puteți exporta toate recenziile într-un fișier pe care îl puteți salva pe dispozitiv sau în stocarea cloud la alegerea dvs.",
      },
      {
        question: "WasOK îmi urmărește locația?",
        answer:
          "Nu, WasOK nu vă urmărește locația. Deși puteți introduce manual numele magazinului de unde ați cumpărat un produs, aplicația nu utilizează GPS sau servicii de localizare.",
      },
      {
        question: "Pot folosi WasOK pe mai multe dispozitive?",
        answer:
          "În prezent, WasOK nu se sincronizează între dispozitive deoarece toate datele sunt stocate local. Fiecare dispozitiv va avea propria bază de date separată de produse și recenzii.",
      },
      {
        question: "Ce se întâmplă dacă un cod de bare nu se scanează?",
        answer:
          "Dacă un cod de bare nu se scanează, asigurați-vă că este bine iluminat și în focus. De asemenea, puteți încerca să curățați lentila camerei. Dacă codul de bare este deteriorat sau neclar, este posibil să puteți introduce manual numărul codului de bare.",
      },
    ],
    cta: {
      heading: "Mai aveți întrebări?",
      body: "Contactați echipa noastră de suport — suntem bucuroși să vă ajutăm.",
      button: "Contactați suportul",
    },
  },
  support: {
    pageTitle: "Suport",
    seoTitle: "Suport — WasOK",
    seoDescription:
      "Obțineți ajutor cu WasOK: contactați suportul, raportați erori și trimiteți feedback.",
    getHelp: {
      title: "Obțineți ajutor",
      body: "Suntem aici pentru a vă ajuta să profitați la maximum de WasOK. Dacă întâmpinați probleme sau aveți întrebări, avem mai multe resurse disponibile pentru a vă ajuta.",
    },
    faq: {
      title: "Întrebări frecvente",
      body: "Înainte de a ne contacta, verificați secțiunea de întrebări frecvente unde răspundem la cele mai comune întrebări despre WasOK. Veți găsi informații detaliate despre modul în care funcționează aplicația, confidențialitate, stocarea datelor și multe altele.",
    },
    contact: {
      title: "Contactați suportul",
      body: "Dacă nu găsiți răspunsul pe care îl căutați, echipa noastră de suport este gata să ajute. Ne puteți contacta la:",
      emailLabel: "Email:",
      responseTime: "De obicei răspundem în 24-48 de ore",
    },
    bugs: {
      title: "Raportarea erorilor",
      body: "Ați găsit o eroare? Apreciem ajutorul dvs. în a face WasOK mai bun. Când raportați o eroare, vă rugăm să includeți:",
      items: [
        "O descriere detaliată a problemei",
        "Pașii pentru reproducerea problemei",
        "Modelul dispozitivului dvs. și versiunea Android",
        "Capturi de ecran sau înregistrări video ale ecranului, dacă este posibil",
      ],
      sendPrefix: "Trimiteți rapoarte de erori la:",
    },
    featureRequests: {
      title: "Cereri de funcționalități",
      bodyBefore: "Aveți o idee pentru o nouă funcționalitate? Ne-ar plăcea să auzim de la dvs.! Trimiteți sugestiile dvs. la",
      bodyAfter:
        ". Deși nu putem implementa fiecare solicitare, luăm în considerare cu atenție tot feedback-ul atunci când planificăm actualizări viitoare.",
    },
    knownIssues: {
      title: "Probleme cunoscute",
      body: "În prezent, suntem conștienți de următoarele probleme și lucrăm la rezolvarea lor:",
      items: [
        "Unele coduri de bare pot să nu se scaneze în condiții de lumină slabă — încercați să folosiți o lanternă",
        "Notele de produs foarte lungi pot dura un moment pentru a se salva pe dispozitivele mai vechi",
        "Miniaturile imaginilor pot apărea pixelate pe afișajele de înaltă rezoluție",
      ],
    },
    appUpdates: {
      title: "Actualizări ale aplicației",
      body: "Lansăm în mod regulat actualizări cu funcții noi, îmbunătățiri și corecții de erori. Asigurați-vă că mențineți WasOK actualizat prin Google Play Store pentru a obține cele mai recente îmbunătățiri.",
    },
    community: {
      title: "Comunitate",
      body: "Alăturați-vă comunității noastre de utilizatori care iau decizii de cumpărare mai inteligente cu WasOK. Împărtășiți sfaturi, puneți întrebări și conectați-vă cu alți utilizatori pe canalele noastre sociale.",
    },
    emergency: {
      title: "Suport de urgență",
      body: 'Dacă întâmpinați o problemă critică care vă împiedică să folosiți aplicația, vă rugăm să marcați e-mailul dvs. ca „URGENT” în linia de subiect, iar noi vom prioritiza solicitarea dvs.',
    },
    cta: {
      heading: "Mai aveți nevoie de ajutor?",
      body: "Echipa noastră de suport este aici pentru dvs. Nu ezitați să ne contactați cu orice întrebări sau nelămuriri.",
      button: "Trimiteți e-mail suportului",
    },
  },
  advertising: {
    pageTitle: "Publicitate și monetizare",
    seoTitle: "Publicitate — WasOK",
    seoDescription: "Cum abordează WasOK publicitatea și monetizarea.",
    approach: {
      title: "Abordarea noastră",
      body: "La WasOK, credem că obiceiurile dvs. de cumpărături și opiniile despre produse sunt private și personale. Modelul nostru de afaceri reflectă această valoare fundamentală.",
    },
    noAds: {
      title: "Fără reclame",
      body: "WasOK nu afișează nicio reclamă. Nu vă vom arăta niciodată reclame bazate pe produsele pe care le scanați, evaluările pe care le acordați sau orice alte date pe care le creați în aplicație. Experiența dvs. cu WasOK este complet fără reclame.",
    },
    noDataSelling: {
      title: "Fără vânzare de date",
      body: "Nu vindem, nu închiriem și nu partajăm datele dvs. cu agenți de publicitate, brokeri de date sau orice terțe părți. Deoarece toate datele dvs. sunt stocate local pe dispozitiv, nici măcar noi nu avem acces la ele. Recenziile dvs. de produse, listele de cumpărături și notele vă aparțin doar dvs.",
    },
    noTracking: {
      title: "Fără urmărire",
      body: "WasOK nu folosește pixeli de urmărire, servicii de analiză sau orice altă tehnologie care vă monitorizează comportamentul sau partajează informații cu terțe părți. Nu urmărim ce produse scanați, din ce magazine cumpărați sau cum utilizați aplicația.",
    },
    sustainability: {
      title: "Cum rămânem sustenabili",
      body: "Vă întrebați poate cum menținem WasOK gratuit fără reclame sau vânzare de date. Abordarea noastră este simplă:",
      items: [
        {
          label: "Gratuit și deschis:",
          text: "WasOK este gratuit pentru toată lumea, fără niveluri premium sau bariere de plată",
        },
        {
          label: "Operare eficientă:",
          text: "Menținem costurile scăzute construind software eficient, axat pe confidențialitate",
        },
        {
          label: "Donații opționale:",
          text: "Utilizatorii care iubesc WasOK ne pot susține prin donații voluntare",
        },
        {
          label: "Sursă deschisă:",
          text: "Putem oferi servicii de consultanță sau dezvoltare personalizată pentru organizații",
        },
      ],
    },
    noAffiliate: {
      title: "Fără linkuri afiliate",
      body: "WasOK nu folosește linkuri afiliate și nu primește comisioane de la comercianți. Când scanați un produs, nu vă redirecționăm nicăieri pentru a-l cumpăra. Aplicația este destinată exclusiv evidenței personale și luării deciziilor.",
    },
    noPromotions: {
      title: "Fără promovarea produselor",
      body: "Nu acceptăm plăți de la mărci sau producători pentru a le promova produsele. WasOK nu va sugera niciodată produse, nu va evidenția anumite mărci și nu vă va influența evaluările în niciun fel. Opiniile dvs. vă aparțin doar dvs.",
    },
    partnerships: {
      title: "Parteneriate cu terți",
      body: "WasOK nu colaborează cu companii de marketing, agregatori de date sau rețele publicitare. Operăm independent și prioritizăm confidențialitatea dvs. mai presus de orice altceva.",
    },
    future: {
      title: "Planuri de viitor",
      body: "Ne angajăm să menținem WasOK fără reclame și axat pe confidențialitate. Dacă va trebui vreodată să introducem un model de afaceri sustenabil în viitor, vom:",
      items: [
        "Anunța orice schimbare cu mult timp în avans",
        "Nu vom compromite niciodată confidențialitatea sau securitatea datelor",
        "Oferi întotdeauna o modalitate de a folosi aplicația fără urmărire sau reclame",
        "Asculta feedback-ul și preocupările utilizatorilor",
      ],
    },
    supporting: {
      title: "Susținerea WasOK",
      body: "Dacă iubiți WasOK și doriți să susțineți misiunea noastră de memorie a cumpărăturilor axată pe confidențialitate, puteți:",
      items: [
        "Să povestiți prietenilor și familiei despre aplicație",
        "Să lăsați o recenzie pozitivă pe Google Play Store",
        "Să ne împărtășiți feedback-ul și sugestiile dvs.",
        "Să luați în considerare o donație voluntară (când este disponibilă)",
      ],
    },
    cta: {
      heading: "Întrebări despre politicile noastre?",
      body: "Suntem transparenți cu privire la modul în care funcționează WasOK. Dacă aveți întrebări despre abordarea noastră privind confidențialitatea, monetizarea sau sustenabilitatea, vă rugăm să ne contactați.",
      button: "Contactați-ne",
    },
  },
};
